import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Lesson, LessonStatus } from './lesson.model';
import { LessonPopupService } from './lesson-popup.service';
import { LessonService } from './lesson.service';
import { CRUD_ACTIONS } from '../../shared/index';

@Component({
    selector: 'jhi-lesson-confirm-executed-dialog',
    templateUrl: './lesson-confirm-executed-dialog.component.html'
})
export class LessonConfirmExecutedDialogComponent {

    lesson: Lesson;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private lessonService: LessonService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['lesson', , 'lessonFamily', 'lessonStatus', 'reservation'
            , 'reservationStatus', 'student', 'classType']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmExecuted(id: number) {
        let copy: Lesson = Object.assign({}, this.lesson);

        copy.status = LessonStatus.EXECUTED;
        this.lessonService.update(copy).subscribe(result => {
            this.eventManager.broadcast({
                name: 'lessonExecuted',  content: {
                    action: CRUD_ACTIONS.UPDATE,
                    content: result
                }
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-lesson-confirm-executed-popup',
    template: ''
})
export class LessonConfirmExecutedPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private lessonPopupService: LessonPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.lessonPopupService
                .open(LessonConfirmExecutedDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson-confirm-executed-dialog.component.ts